/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

:local(.sideNavItemWrapper)
  display flex
  align-items center
  li
    flex-grow 1
    min-width 216px
    overflow hidden
  :global(.withButton)
    max-width 216px

:local(.toggleIcon)
  margin-left -18px
  pointer-events none
  svg
    display block
    margin auto

:local(.infoIcon)
  margin-left: 6px;
  min-width: 18px;
  padding: 0;

:local(.railPluginList)
  margin-bottom 30px

  :global(.heading)
    h2
      height auto
      overflow-wrap break-word
      white-space normal

